<template>
	<div
		v-if="isLoggedIn && accountUserDetail"
		class="user-avatar"
	>
		<div class="user-avatar__image">
			<img
				v-if="accountUserDetail.image"
				class="user-avatar__image-element"
				:src="accountUserDetail.image"
				loading="eager"
			>
			<img
				v-else-if="accountUserDetail.avatar"
				class="user-avatar__image-element"
				:src="themeImagePath(`${accountUserDetail.avatar}.png`)"
				loading="eager"
			>
			<InitialsAvatar
				v-else
				:initials="initials"
				class="user-avatar__image-element"
			/>
		</div>
		<div class="user-avatar__meter" ref="levelMeter"/>
	</div>
</template>

<script>
import {mapGetters} from 'vuex'
import Crclrrr from 'crclrrr';
import InitialsAvatar from '@/components/InitialsAvatar';

export default {
	components: {
		InitialsAvatar
	},
	data() {
		return {
			crclrrr: null,
		}
	},
	computed: {
		...mapGetters('account', [
			'isLoggedIn',
			'accountUserDetail',
			'accountClubDetail',
		]),
		initials() {
			return this.accountUserDetail.firstName.charAt(0) + this.accountUserDetail.lastName.charAt(0);
		}
	},
	watch: {
		isLoggedIn(value) {
			if (value) {
				this.setupProgress();
			}
		},
		'accountClubDetail.progress'(value) {
			this.setProgressValue(value);
		}
	},
	methods: {
		setupProgress() {
			if (this.crclrrr) {
				return;
			}
			this.crclrrr = new Crclrrr(this.$refs.levelMeter, {
				size: 160,
				border: 8,
				round: true,
				bg: 'var(--user-level-progress-bg)',
				progress: 'var(--user-level-progress-fg)',
				duration: 250,
			});
			this.setProgressValue(this.accountClubDetail?.progress || 0)
		},
		setProgressValue(value) {
			if (this.crclrrr) {
				this.crclrrr.value = value;
			}
		}
	},
	mounted() {
		if (this.isLoggedIn) {
			this.setupProgress();
		}
	}
}
</script>

<style>

</style>
